// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__12M94","right":"Footer_right__-rBh0","buttons":"Footer_buttons__sA0PB"};